<template>
    <div>
        <div class="page-title">
            <h4>{{$t('txt.conversatie')}}</h4>
        </div>
        <div class="chat-box" v-if="hasMessages">
            <ul class="chat">
                <li class="a" v-for="message in messages" :key="message.id"
                   :class="[pageItemClass, (message.sender) ? ((message.sender.id === $store.getters.user.id) ? rightClass : leftClass) : leftClass]"
                >
                    <small class="pull-right message-date">
                        <span class="glyphicon glyphicon-time"></span>
                        {{message.created_at}}
                    </small>
                    <span class="chat-img pull-left">
                          <img src="http://placehold.it/50/55C1E7/fff&text=U" alt="User Avatar" class="img-circle" />
                    </span>
                    <div class="chat-body">
                        <div class="header">
                            <strong class="primary-font" v-if="message.sender"> {{message.sender.first_name}} {{message.sender.last_name}} </strong>
                        </div>
                        <pre>
                           {{message.message}}
                        </pre>
                        <div class="convo-docs-wrapper" v-if="message.media.length">
                            <a v-for="media in message.media" :key="media.id"  v-bind:href="media.link" class="convo-doc" target="_blank">
                                <i class="far fa-file-alt"></i>
                            {{media.file_name}}
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="chat-footer">
            <form class="chat-send-form" id="messages-form">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12 form-group">
                    <div class="location-header">
                        <h4> {{$t('placeholder.mesaj')}} </h4>
                    </div>
                    <div class="inner-location-group form-group textarea-group">
                        <textarea name='message' v-validate="'min:10'" class="form-control" v-model="notes" rows="10"> </textarea>
                        <p class="custom-error-info"> {{errors.first('message')}} </p>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <b-form-file
                            name="files[]"
                            v-model="file"
                            ref="file-input"
                            :state="Boolean(file)"
                            placeholder="Alege Fisierul..."
                            drop-placeholder="Drop file here..."
                            id='file'
                            multiple
                        ></b-form-file>
                    </div>
                 </div>
                <button type="button" class="send-message" @click.prevent='SendMessage()'>
                    <i class="far fa-paper-plane"></i>
                    {{$t('txt.trimiteMesaj')}}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import MessagesService from '../../api-services/messages.service.js'
export default {
  name: 'Messages',
  data () {
    return {
      rightClass: 'right-message',
      leftClass: 'left-message',
      pageItemClass: 'a',
      notes: null,
      messages: null,
      file: null,
      hasMessages: false
    }
  },
  methods: {
    SendMessage () {
      let formData = new FormData(document.getElementById('messages-form'))
      MessagesService.create(formData)
        .then((response) => {
          document.getElementById('file').value = ''
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('messages.mesajCreat'),
            'animation-type': 'css'
          })
          location.reload()
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  mounted () {
    this.$store.dispatch('hideLoading')
    MessagesService.get(this.$store.getters.user.id)
      .then((response) => {
        console.log(response.data.data, 'CONSOLE LOG')

        this.messages = response.data.data
        if (this.messages.length) {
          this.hasMessages = true
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>
